import React from "react";
import { Link } from "gatsby";
import { scale } from "../utils/typography";
import styled from "styled-components";
import NavigationSimple from "./navigation--simple";
import FooterSimple from "./footer-simple";
import "normalize.css";
import "../styles/global.css";

const LayoutSimple = ({ location, title, children }) => {
  const rootPath = `${__PATH_PREFIX__}/`;
  let header;

  const LayoutContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh; /* Fill the whole viewport */
    margin: 0;
    padding: 2rem;
    /* max-width: 1000px; */

    /* @media (max-width: 768px) {
      margin: 150px auto 100px;
      padding: 0 1rem 1rem;
    } */
  `;

  if (location.pathname === rootPath) {
    header = (
      <h1
        style={{
          marginTop: 0,
          display: "none",
        }}
      >
        <Link
          style={{
            boxShadow: `none`,
            textDecoration: `none`,
            color: `inherit`,
          }}
          to={`/`}
        >
          {title}
        </Link>
      </h1>
    );
  } else {
    header = <h1>{title}</h1>;
  }
  return (
    <LayoutContainer>
      <div className="container">
        <NavigationSimple />
        <div className="container">
          {header}
          {children}
        </div>
      </div>
      <FooterSimple />
    </LayoutContainer>
  );
};

export default LayoutSimple;
